<script lang="ts">
    import { events } from "../../store"

    import { apiBaseURL } from "../../config"

    import Sidebar from "../page/Sidebar.svelte"
    import Event from "../page/Event.svelte"
</script>

<div class="container">
    <div class="row">
        <div class="col-md-10">
            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="layout layout-vertical layout-gap-md">
                <h1>Veranstaltungen</h1>
                {#each $events || [] as event}
                    <Event event="{event}" overview="{true}" />
                {/each}
            </div>

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />
        </div>
        <div class="col-md-2">
            <Sidebar />
        </div>
    </div>
</div>
